import './Competitions.css';
import { useEffect } from 'react';

function Competitions({ onNavigateHome }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const competitions = [
    {
      name: "Division Press Conference — Sports Writing",
      date: "2016",
      role: "Competitor / Writer",
      award: "Champion (1st Place)",
      desc: "Competed against writers from across the division. Secured the top spot for demonstrating precise, analytical, and engaging coverage of sporting events under extreme time pressure."
    },
    {
      name: "Regional Press Conference — Sports Writing",
      date: "2016",
      role: "Division Representative",
      award: "2nd Place",
      desc: "Represented the DepEd Lipa Division at the regional level. Showcased strong journalistic prowess and ability to adapt to complex sports scenarios, finishing among the top tier competitors."
    }
  ];

  return (
    <div className="comp-page">
      {/* ── Header ── */}
      <header className="comp-header">
        <div className="comp-header-inner">
          <button className="comp-back-btn" onClick={onNavigateHome}>
            <span className="comp-back-arrow">&#8592;</span> Back to Portfolio
          </button>
          <nav className="comp-breadcrumb">
            <span className="comp-bc-home" onClick={onNavigateHome}>Home</span>
            <span className="comp-bc-sep">/</span>
            <span className="comp-bc-current">Competitions</span>
          </nav>
        </div>
      </header>

      {/* ── Hero Strip ── */}
      <div className="comp-hero-strip">
        <div className="comp-strip-inner">
          <p className="comp-strip-label">Events & Challenges</p>
          <h1 className="comp-strip-name">Competitions</h1>
          <p className="comp-strip-role">A showcase of competitive events I have participated in.</p>
        </div>
      </div>

      {/* ── Main Content ── */}
      <main className="comp-main">
        <div className="comp-list">
          {competitions.map((comp, idx) => (
            <div className="comp-card" key={idx}>
              <div className="comp-card-left">
                <div className="comp-date">{comp.date}</div>
                <div className="comp-award-badge">{comp.award}</div>
              </div>
              <div className="comp-card-right">
                <h3 className="comp-name">{comp.name}</h3>
                <p className="comp-role">Role: <strong>{comp.role}</strong></p>
                <p className="comp-desc">{comp.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </main>

      {/* ── Footer ── */}
      <footer className="comp-footer">
        <p>Christian D. Kalaw &copy; {new Date().getFullYear()}</p>
        <button className="comp-footer-back" onClick={onNavigateHome}>Back to Portfolio</button>
      </footer>
    </div>
  );
}

export default Competitions;
